import classNames from "lib/classNames";
import LocaleNumber from "./LocaleNumber";

export default function CountBadge({
  active = false,
  count,
  className = "",
  formatter,
}: {
  active?: boolean;
  count?: number;
  className?: string;
  formatter?: (number: number) => string;
}) {
  const combinedClassName = classNames(
    className,
    active
      ? "bg-accent text-accent-foreground"
      : "bg-secondary text-secondary-foreground",
    "break-keep rounded-lg text-sm px-1 py-0.5"
  );
  return (
    <LocaleNumber
      formatter={formatter}
      number={count}
      className={combinedClassName}
    />
  );
}
